import { render, staticRenderFns } from "./setting-list-card.vue?vue&type=template&id=a3e8ee6e&"
import script from "./setting-list-card.vue?vue&type=script&lang=js&"
export * from "./setting-list-card.vue?vue&type=script&lang=js&"
import style0 from "./setting-list-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QBtn})
